export default {"src":"/_next/static/media/connect-wallet.c35e620e.svg","height":105,"width":370};